import { z } from 'zod';
import { IllegalArgumentError } from 'faro-common-model';
import { uuidish } from '../../utils/uuidish.js';
export const assessmentMeasurementSystemOptionSchema = z.object({
    required: z.boolean(),
    partName: z.string(),
    name: z.string(),
});
export function toAssessmentMeasurementSystemOption(option) {
    const result = assessmentMeasurementSystemOptionSchema.safeParse(option);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid AssessmentMeasurementSystemOption object. ${result.error.message}`);
    }
    return result.data;
}
export const systemOptionsByAssessmentMeasurementIdSchema = z.object({
    assessmentMeasurementId: uuidish,
    options: z.array(assessmentMeasurementSystemOptionSchema),
});
export function toSystemOptionsByAssessmentMeasurementId(assessmentMeasurementSystemOptions) {
    const result = systemOptionsByAssessmentMeasurementIdSchema.safeParse(assessmentMeasurementSystemOptions);
    if (!result.success) {
        throw new IllegalArgumentError(`Invalid SystemOptionsByAssessmentMeasurementId object. ${result.error.message}`);
    }
    return result.data;
}
//# sourceMappingURL=assessment-measurement-system-option.js.map